export enum MercerJobType {
  Family = 'Family',
  SubFamily = 'Sub Family',
  Specialization = 'Specialization',
  CareerStream = 'Career Stream',
  CareerLevel = 'Career Level',
  PositionClass = 'Position Class'
}
